'use client';

import { Home, Menu, Users } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useUIStore } from '@/store/ui-store';
import { BUTTON_COLOR_ACTIVE } from '../constants';

const items = [
  { label: 'Home', href: '/', icon: Home },
  { label: 'Characters', href: '/character', icon: Users },
];

export const Sidebar = () => {
  const pathname = usePathname();
  const isSidebarMenuOpen = useUIStore((state) => state.isSidebarMenuOpen);
  const toggleSidebar = useUIStore((state) =>
    state.isSidebarMenuOpen ? state.closeSidebarMenu : state.openSidebarMenu,
  );

  return (
    <aside
      className={`${
        isSidebarMenuOpen ? 'w-64' : 'w-20'
      } bg-gray-800 text-white flex flex-col transition-all duration-300 shadow-lg`}
    >
      <div
        className={`flex items-center p-4 border-b border-gray-700 h-16 ${
          isSidebarMenuOpen ? 'justify-between' : 'justify-center'
        }`}
      >
        {isSidebarMenuOpen && (
          <h1 className="text-xl font-bold tracking-wider">BB API 🧪</h1>
        )}
        <button
          type="button"
          onClick={toggleSidebar}
          className="p-2 rounded-md hover:bg-gray-700 transition-colors"
        >
          <Menu className="w-6 h-6" />
        </button>
      </div>

      <div className="flex flex-col justify-between flex-1">
        <nav className="px-3 mt-4 space-y-2">
          {items.map((item) => {
            const isActive = pathname === item.href;
            const Icon = item.icon;
            return (
              <Link
                key={item.href}
                href={item.href}
                className={`flex items-center gap-4 py-2.5 rounded-lg transition-colors text-sm font-medium ${
                  isActive
                    ? `${BUTTON_COLOR_ACTIVE} text-white`
                    : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                } ${isSidebarMenuOpen ? 'px-4' : 'justify-center'}`}
              >
                <Icon className="w-5 h-5 flex-shrink-0" />
                {isSidebarMenuOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};
